import * as actionTypes from "../../../actions/actionTypes";
import {updateObject} from "../../../../utils/utils";

const initialState = {
    success: false,
    loading: false,
    error: null,
};

const authRequestNewPasswordStart = (state, action) => {
    return updateObject(state, {
        ...initialState,
        loading: true,
        error: null
    })
};

const authRequestNewPasswordSuccess = (state, action) => {
    return updateObject(state, {
        ...initialState,
        loading: false,
        error: null,
        success: true,
    })
};


const authRequestNewPasswordFail = (state, action) => {
    return updateObject(state, {
        ...initialState,
        loading: false,
        error: action.payload.error,
        success: false,
    })
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_REQUEST_NEW_PASSWORD_START :
            return authRequestNewPasswordStart(state, action);
        case actionTypes.AUTH_REQUEST_NEW_PASSWORD_SUCCESS :
            return authRequestNewPasswordSuccess(state, action);
        case actionTypes.AUTH_REQUEST_NEW_PASSWORD_FAIL :
            return authRequestNewPasswordFail(state, action);
        default :
            return state;
    }
};

export default reducer;